<template>
    <div>
        <div class="column-setting">
          <!-- Кнопка для открытия настроек -->
          <font-awesome-icon icon="sliders" @click="openColumnSettings" class="select-column"/>
          <button 
          v-if="waitConfirmCount>0" 
          @click="changeTable(true)" 
          class="work-trip-btn">Ожидают подтверждения ({{ waitConfirmCount }})
          </button>
        </div>
        <!-- Попап для выбора колонок -->
        <column-settings 
          v-if="isSettingsOpen" 
          :isOpen="isSettingsOpen" 
          :columns="columns" 
          :savedColumns="selectedColumns" 
          @updateColumns="updateColumnSelection" 
          @close="closeColumnSettings"
        />
        
        <div class="drop-btn-block">
            <div v-show="selectedItems.length > 0" class="save-button-drop">
                <button class="save-button hover" @click="saveTmsTemplate">Сохранить</button>
                <button class="cancel-button hover" @click="clearSelect">Отменить</button>
            </div>
        </div>
        
        <my-loader v-if="isLoading"></my-loader>
        <div v-else class="table-page">
            <!-- Телефон: каждый рейс — карточка с главным, без прокрутки вбок (решение Анны 04.11.2026) -->
            <ul v-if="trips.length>0" class="trip-cards">
              <li v-for="trip in trips" :key="'c' + trip.id">
                <a :href="'/trips/' + trip.id" class="tc" @click.prevent="$router.push('/trips/' + trip.id)">
                  <span class="tc__top">
                    <b class="tc__num">{{ trip.trip_id }}</b>
                    <font-awesome-icon v-if="trip.is_top" class="tc__trophy" icon="fa-solid fa-trophy" title="Топ-клиент" />
                    <span class="tc__status"><trip-status-label :status="trip.work_status && trip.work_status.name" /></span>
                  </span>
                  <span class="tc__route">{{ trip.tms_city_out || '—' }} <i>→</i> {{ trip.tms_city_in || '—' }}</span>
                  <span v-if="trip.tms_name_endpoint" class="tc__client">{{ trip.tms_name_endpoint }}</span>
                  <span class="tc__times">
                    <span><em>Погрузка</em>{{ plannedTimeText(trip, 'load') }}</span>
                    <span><em>Выгрузка</em>{{ plannedTimeText(trip, 'unload') }}</span>
                  </span>
                  <span class="tc__foot">
                    <span>{{ trip.responsible ? trip.responsible.name : 'Без ответственного' }}</span>
                    <span v-if="trip.executor_price" class="tc__price">{{ trip.executor_price }} ₽ · {{ trip.nds ? 'с НДС' : 'без НДС' }}</span>
                  </span>
                  <span v-if="outcomeLabel(trip)" :class="['tc__reason', outcomeTone(trip)]">{{ outcomeLabel(trip) }}</span>
                </a>
              </li>
            </ul>
            <div class='content'>
                <table v-if="trips.length>0" class="company-table">
                  <thead>
                      <tr>
                        <th v-if="isColumnVisible('upload')">Загрузить шаблон</th>
                        <th v-if="isColumnVisible('status')">Статус заявки</th>
                        <th v-if="isColumnVisible('reason')">Причина</th>
                        <th v-if="isColumnVisible('number')">Номер</th>
                        <th v-if="isColumnVisible('startDate')">Дата начала</th>
                        <th v-if="isColumnVisible('endDate')">Дата завершения</th>
                        <th v-if="isColumnVisible('loadTime')">Время погрузки</th>
                        <th v-if="isColumnVisible('factLoadTime')">Фактическое время погрузки</th>
                        <th v-if="isColumnVisible('unloadTime')">Время выгрузки</th>
                        <th v-if="isColumnVisible('factUnloadTime')">Фактическое время выгрузки</th>
                        <th v-if="isColumnVisible('departure')">Отправление</th>
                        <th v-if="isColumnVisible('destination')">Назначение</th>
                        <th v-if="isColumnVisible('distance')">Расстояние</th>
                        <th v-if="isColumnVisible('vehicleType')">Тип ТС</th>
                        <th v-if="isColumnVisible('price')">Цена</th>
                        <th v-if="isColumnVisible('maxWeight')">Максимальный вес</th>
                        <th v-if="isColumnVisible('spot')">СПОТ</th>
                        <th v-if="isColumnVisible('name')">Название</th>
                        <th v-if="isColumnVisible('manager')">Менеджер</th>
                        <th v-if="isColumnVisible('statusWork')">Статус</th>
                        <th v-if="isColumnVisible('remainingTime')">До завершения</th>
                        <th v-if="isColumnVisible('top8')">Топ8</th>
                        <th v-if="isColumnVisible('executorPrice')">Ставки</th>
                        <th v-if="isColumnVisible('nds')">Ндс</th>
                        <th v-if="isColumnVisible('terms')">Сроки</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="trip in trips" :key="trip.id" @click="$router.push(`/trips/${trip.id}`)" class="row-card">
                        <td v-if="isColumnVisible('status')">{{ trip.tms_request_status }}</td>
                        <td v-if="isColumnVisible('reason')" :class="['outcome-cell', outcomeTone(trip)]" :title="trip.outcome_reason || ''">{{ outcomeLabel(trip) }}</td>
                        <td v-if="isColumnVisible('number')">{{ trip.trip_id }}</td>
                        <td v-if="isColumnVisible('startDate')">{{ trip.tms_date_start }}</td>
                        <td v-if="isColumnVisible('endDate')">{{ trip.tms_date_end }}</td>
                        <td v-if="isColumnVisible('loadTime')" title="Время площадки; в скобках — по Ульяновску">{{ plannedTimeText(trip, 'load') }}</td>
                        <td v-if="isColumnVisible('factLoadTime')">{{ getFactDate(trip, 'load') }}</td>
                        <td v-if="isColumnVisible('unloadTime')" title="Время площадки; в скобках — по Ульяновску">{{ plannedTimeText(trip, 'unload') }}</td>
                        <td v-if="isColumnVisible('factUnloadTime')">{{ getFactDate(trip, 'unload') }}</td>
                        <td v-if="isColumnVisible('departure')">{{ trip.tms_city_out }}</td>
                        <td v-if="isColumnVisible('destination')">{{ trip.tms_city_in }}</td>
                        <td v-if="isColumnVisible('distance')">{{ trip.tms_total_distance }}</td>
                        <td v-if="isColumnVisible('vehicleType')">{{ trip.tms_cargo ? trip.tms_cargo.split(' ')[0] : trip.tms_cargo }}</td>
                        <td v-if="isColumnVisible('price')">{{ trip.tms_price }}</td>
                        <td v-if="isColumnVisible('maxWeight')">{{ trip.tms_max_weight / 1000 }}</td>
                      
                        <td v-if="isColumnVisible('spot')" @click.stop>
                          <select :value="trip.spot_type" name="spot" class="select-spot" @change="updateSpot($event,trip.id)">
                            <option value=""></option>
                            <option value="СПОТ" class="spot-label">СПОТ</option>
                            <option value="СПОТ ИМ" class="spot-label">СПОТ ИМ</option>
                          </select>
                        </td>
                        <td v-if="isColumnVisible('name')">
                            <font-awesome-icon 
                                v-if="trip.is_top" 
                                class="top-icon" icon="fa-solid fa-trophy" />
                            <span>{{ trip.tms_name_endpoint }}</span>
                        </td>
                        <td v-if="trip.responsible && isColumnVisible('manager')" >{{ trip.responsible.name }}</td>
                        <td v-else-if="isColumnVisible('manager')">-</td>
                        <td v-if="isColumnVisible('statusWork')">
                            <trip-status-label :status="trip.work_status.name"/>
                        </td>
                        <td v-if="isColumnVisible('remainingTime')">
                          <trip-work-timer :startTime="trip.update_work_status_dt"/>
                        </td>

                        <td v-if="isColumnVisible('top8')">{{ trip.is_top ? 'ТОП-8' : '-' }}</td>
                        <td v-if="isColumnVisible('executorPrice')">{{ trip.executor_price }}</td>
                        <td v-if="isColumnVisible('nds')">{{ trip.nds ? 'С НДС' : 'Без' }}</td>
                        <td v-if="isColumnVisible('terms')">{{ trip.payment_terms && trip.work_status.name !== 'Новый' ? trip.payment_terms.name : '-' }}</td>
                        
                      </tr>
                  </tbody>
                </table>
            </div>
        </div>
    </div>
</template>


<script>
import { ref,onBeforeMount } from 'vue'
import ColumnSettings from './ColumnSettings.vue';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
import { firstLoading, formatPlaceTime, lastUnloading, outcomeLabel, outcomeTone, plannedOf } from '../helpers/placeTime.mjs';

export default {
  name: 'CargosTable',
  props:['trips','isLoading','waitConfirmCount'],
  components:{ColumnSettings},
  setup(props,{emit}){
    const selectedItems = ref([])
    const columns = [
      { key: 'status', label: 'Статус заявки' },
      { key: 'reason', label: 'Причина' },
      { key: 'number', label: 'Номер' },
      { key: 'startDate', label: 'Дата начала' },
      { key: 'endDate', label: 'Дата завершения' },
      { key: 'loadTime', label: 'Время погрузки' },
      { key: 'factLoadTime', label: 'Фактическое время погрузки' },
      { key: 'unloadTime', label: 'Время выгрузки' },
      { key: 'factUnloadTime', label: 'Фактическое время выгрузки' },
      { key: 'departure', label: 'Отправление' },
      { key: 'destination', label: 'Назначение' },
      { key: 'distance', label: 'Расстояние' },
      { key: 'vehicleType', label: 'Тип ТС' },
      { key: 'price', label: 'Цена' },
      { key: 'maxWeight', label: 'Максимальный вес' },
      { key: 'spot', label: 'СПОТ' },
      { key: 'name', label: 'Название' },
      { key: 'manager', label: 'Менеджер' },
      { key: 'statusWork', label: 'Статус' },
      { key: 'remainingTime', label: 'До завершения' },
      { key: 'top8', label: 'Топ8' },
      { key: 'executorPrice', label: 'Ставки' },
      { key: 'nds', label: 'Ндс' },
      { key: 'terms', label: 'Сроки' },
    ];
    const selectedColumns = ref([])
    const isSettingsOpen = ref(false)
    const openColumnSettings = () => {
      isSettingsOpen.value = true;
    };

    const changeTable = (isWait) => {
      emit('changeTable',isWait)
    }

    const closeColumnSettings = () => {
      isSettingsOpen.value = false;
    };

    const updateColumnSelection = (newSelection) => {
      selectedColumns.value = newSelection;
    };

    const loadColumnSelection = () => {
      const savedColumns = localStorage.getItem('selectedColumns');
      if (savedColumns) {
        selectedColumns.value = JSON.parse(savedColumns);
      } else {
        selectedColumns.value = columns.map(col => col.key); // По умолчанию все колонки
      }
    };

    const isColumnVisible = (columnKey) => {
      return selectedColumns.value.includes(columnKey);
    };

    onBeforeMount(() => {
      loadColumnSelection();
    });



    const updateSpot = (event,trip_id) =>{
      emit('updateSpot',{trip_id,form:{spot_type:event.target.value}})
    }

    const isSelected = (val) => {
      return selectedItems.value.includes(val)
    }

    const clearSelect = ()=>{
      selectedItems.value = []
    }

    const saveTmsTemplate = () =>{
        emit('saveTmsTemplate',selectedItems.value)
        clearSelect()
    }

    // Время точек — местное время площадки и «(по Ульяновску …)» (src/pages/trip/helpers/placeTime.mjs).
    const pointOf = (trip, operation) =>
      operation === 'load' ? firstLoading(trip.route_point) : lastUnloading(trip.route_point)

    const getFactDate = (trip, operation) => {
      const point = pointOf(trip, operation)
      return (point && formatPlaceTime(point.arrival_time, point.timezone)) || '-'
    }

    const plannedTimeText = (trip, operation) => {
      const point = pointOf(trip, operation)
      const fallback = operation === 'load' ? trip.load_trip_time : trip.arrival_trip_time
      return (point && formatPlaceTime(plannedOf(point), point.timezone)) || fallback || '-'
    }

    return{
      changeTable,
      getFactDate,
      plannedTimeText,
      outcomeLabel,
      outcomeTone,
      updateSpot,
      clearSelect,
      isSelected,
      selectedItems,
      saveTmsTemplate,
      columns,
      selectedColumns,
      isSettingsOpen,
      openColumnSettings,
      closeColumnSettings,
      updateColumnSelection,
      isColumnVisible,
    }
  },

};

</script>

<style scoped>
.content {
  /* font-size: 10px; */
  margin-top: 10px;
  /* display: flex; */
  /* flex-direction: column; */
  /* justify-content: space-between; */
  /* align-items: center; */
}

.company-table {
  margin-left: 20px;
  margin-right: 20px;
  border-collapse: collapse;
}

.company-table th,
.company-table td {
  text-align: center;
  padding: 3px;
  border: 1px solid #ccc;
}

.company-table th {
  font-weight: bold;
}

.row-card:hover{
  background-color: rgba(224, 187, 72, 0.4);
  cursor: pointer;
}


.top-icon{
  margin-right: 5px;
  width: 15px;
  height: 15px;
  color: #ae4ddb;
}

.icon-select{
  border-radius: 3px;
  width: 40px;
  height: 18px;
  padding: 1px;
}

.icon-play{
  border: 1px solid #47a01c;
  color: #47a01c;
}

.icon-stop{
  border: 1px solid #b83235;
  color: #b83235;
}

.icon-clock{
  border: 1px solid #dfda34;
  color: #dfda34;
}


.icon-check{
  border: 1px solid #1765ee;
  color: #1765ee;
}

.save-button-drop{
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 15px;
  position: fixed;
  bottom: 20px;
  left: 60px;
}

.save-button{
  width: 150px;
  height: 30px;
  border: 1px solid;
  border-radius: 5px;
  background-color: #007BFF;
  color: white;
}

.cancel-button{
  width: 150px;
  height: 30px;
  border: 1px solid;
  border-radius: 5px;
  background-color: #b83235;
  color: white;
}

.hover:hover{
  cursor: pointer;
  background-color: #444;
}

.drop-btn-block{
  position: relative;
}

.icon-yandex-indicate {
  color: rgba(75, 228, 33, 0.8);
}

.select-spot{
  background-color: white;
  text-align: center;
  padding: 3px;  
  border-radius: 5px;
  color: #1765ee;
}


.column-setting{
  display: flex;
  align-items: center;
}

.select-column {
  margin-left: 20px;
  border-radius: 5px;
  width: 20px;
  height: 20px;
  padding: 5px;
  background-color: rgba(195,228,255,0.3);
}

.outcome-cell.bad {
  color: #c0392b;
  font-weight: 600;
}

.work-trip-btn {
  margin-left: 20px;
  border-radius: 5px;
  padding: 5px;
  background-color: rgba(195,52,70,0.7);
  border: 1px solid;
}

</style>

<style scoped>
/* Карточки рейсов для телефона; на компьютере — таблица. */
.trip-cards { display: none; }
@media screen and (max-width: 768px) {
  .table-page > .content { display: none; }
  .trip-cards { display: grid; gap: 10px; list-style: none; margin: 0; padding: 4px 0 16px; }
  .tc { display: flex; flex-direction: column; gap: 6px; padding: 14px; border-radius: 16px; background: #fff;
    border: 1px solid #ebe7dd; box-shadow: 0 10px 24px -20px rgba(31, 36, 48, .5); color: #1f2430; text-decoration: none; }
  .tc:active { transform: scale(.99); background: #fbfaf7; }
  .tc__top { display: flex; align-items: center; gap: 8px; }
  .tc__num { font-size: 16px; font-weight: 800; letter-spacing: -.01em; }
  .tc__trophy { color: #d9b65a; }
  .tc__status { margin-left: auto; }
  .tc__route { font-size: 15px; font-weight: 600; }
  .tc__route i { font-style: normal; color: #b8923a; }
  .tc__client { font-size: 12.5px; color: #6b7180; }
  .tc__times { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; font-size: 12.5px; }
  .tc__times em { display: block; font-style: normal; font-size: 11px; color: #8a8f9c; }
  .tc__foot { display: flex; justify-content: space-between; gap: 8px; flex-wrap: wrap; font-size: 12.5px; color: #4b5161;
    padding-top: 6px; border-top: 1px dashed #ebe7dd; }
  .tc__price { font-weight: 700; color: #1f2430; }
  .tc__reason { align-self: flex-start; font-size: 11.5px; font-weight: 700; padding: 3px 8px; border-radius: 999px; background: #f3f1ec; }
}
</style>
